import { IconButton } from '@/components/atoms/Button';
import { Box, Button } from '@mui/material';
import { styled } from '@mui/material/styles';

export const MapContainer = styled(Box)(() => ({
  position: 'relative',
  width: '100%',
  height: '100%',
}));

export const MapLegendContainer = styled(Box)(() => ({
  width: '100%',
  position: 'absolute',
  top: 24,
  right: 24,
}));

export const MapLoading = styled(Box)(({ theme }) => ({
  width: '100%',
  maxWidth: '160px',
  display: 'flex',
  marginTop: theme.spacing(3),
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(2),
  padding: theme.spacing(1),
  borderRadius: '999px',
  backgroundColor: theme.palette.common.white,
  color: theme.palette.primary.main,
  border: `1px solid ${theme.palette.divider}`,
}));

export const StyledTableMaxContent = styled(Box)(({ theme }) => ({
  width: '100%',
  maxWidth: theme.breakpoints.values.xl,
  margin: '0 auto',
  height: 'auto',
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(0, 3),
  },
}));

export const StyledBottomSheetContent = styled(Box)(({ theme }) => ({
  height: '100%',
  padding: theme.spacing(3),
}));

export const SimpleLegendButton = styled(Button)(({ theme }) => ({
  width: '100%',
  maxWidth: '280px',
  height: 'auto',
  padding: theme.spacing(1.5, 2),
  backgroundColor: theme.palette.common.white,
  color: theme.palette.text.primary,
  textTransform: 'none',
  '&:hover': {
    backgroundColor: theme.palette.common.white,
  },
}));

export const StyledIconButtonContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  gap: theme.spacing(2),
}));

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  width: 40,
  height: 40,
  borderRadius: '4px',
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.common.white,
  padding: theme.spacing(1),
  '&:hover': {
    backgroundColor: theme.palette.common.white,
    filter: 'brightness(0.6)',
  },
}));

export const MapCardContainer = styled('div')(() => ({
  position: 'absolute',
  top: '30%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  zIndex: 1000,
  width: '100%',
  maxWidth: '360px',
}));

export const MapCardArrow = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: '100%',
  left: '50%',
  transform: 'translateX(-50%)',
  width: 0,
  height: 0,
  borderLeft: '12px solid transparent',
  borderRight: '12px solid transparent',
  borderTop: `12px solid ${theme.palette.common.white}`,
  zIndex: 1001,

  // Adiciona uma sombra sutil para combinar com o card
  '&::before': {
    content: '""',
    position: 'absolute',
    top: '-13px',
    left: '-13px',
    width: 0,
    height: 0,
    borderLeft: '13px solid transparent',
    borderRight: '13px solid transparent',
    borderTop: `13px solid ${theme.palette.common.white}`,
    zIndex: -1,
  },
}));

export const MapCardBackdrop = styled('div')(() => ({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 999,
}));

export const ControlsContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'flex-end',
  gap: theme.spacing(2),
}));
